import React from 'react';
import { useSelector } from 'react-redux';
import useExternalScript from '@ao-internal/microfrontend-utilities/lib/useExternalScript';

import {
	getIsBecomingFiveStarMemberCookieValue,
	setIsBecomingMemberAsync,
} from '../utilities/basket-utilities';

const FinanceSlideoutComponent = () => {
	const {
		productId,
		productSku,
		nowPrice,
		memberPrice,
		annualMembershipFee,
		financePromotionCodes,
		financePromotionType,
		financePromotionMonths,
		isInStock,
		upfrontPaymentAmount,
		memberUpfrontPaymentAmount,
		upfrontPaymentPercentage,
		switch24Pricing,
		representativeAprRateString,
		purchaseAprRateString,
	} = useSelector((state) => state.financeSlideout);

	const { UseUpfrontPricingAmounts, UseSwitch24 } = useSelector(
		(state) => state.featureSwitches
	);

	const [isScriptReady, scriptError, FinanceWidget] = useExternalScript(
		window.AO.FinanceSlideoutScriptUrl,
		() => window.financeSlideout.FinanceWidget
	);

	const isInBasket = (sku) => {
		const addToBasketParent = document.getElementById(sku);
		if (addToBasketParent) {
			const addToBasketButton = addToBasketParent.querySelector(
				'[data-testid="add-to-basket-button"]'
			)
				? false
				: true;

			return addToBasketButton;
		}

		return false;
	};

	const getAddToBasketButton = (sku) => {
		const addToBasketParent = document.getElementById(sku);
		return addToBasketParent.querySelector(
			'[data-testid="add-to-basket-button"]'
		);
	};

	const addToBasket = async ({ productSku: sku, isBecomingMember }) => {
		if (getIsBecomingFiveStarMemberCookieValue() !== isBecomingMember) {
			await setIsBecomingMemberAsync(isBecomingMember);
		}
		getAddToBasketButton(sku)?.click();
	};

	if (isScriptReady && !scriptError) {
		return (
			<FinanceWidget
				eventPanelTrigger="ListerPageFinanceComponent"
				productId={productId}
				productSku={productSku}
				nowPrice={nowPrice}
				memberPrice={memberPrice}
				annualMembershipFee={annualMembershipFee}
				financePromotionCodes={financePromotionCodes}
				financePromotionType={financePromotionType ?? null}
				financePromotionMonths={financePromotionMonths ?? null}
				isInStock={isInStock}
				isInBasket={isInBasket}
				addToBasket={addToBasket}
				memberUpfrontPaymentAmount={memberUpfrontPaymentAmount}
				upfrontPaymentAmount={upfrontPaymentAmount}
				upfrontPaymentPercentage={upfrontPaymentPercentage}
				upfrontPaymentsEnabled={UseUpfrontPricingAmounts}
				switch24Enabled={UseSwitch24}
				switch24Pricing={switch24Pricing}
				representativeAprRateString={representativeAprRateString}
				purchaseAprRateString={purchaseAprRateString}
			/>
		);
	}

	return null;
};

export default FinanceSlideoutComponent;
